import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom'
import TopHeader from '../../Header/TopHeader'
import Navbar from '../../Header/Navbar'
import { useParams } from "react-router-dom";
import '../../Css/PropertiesShip.css'
import '../../Css/DocumentRequire.css'
import Footer from '../../Footer/Footer'
import PRI from '../../Images/PRI.png'
import dummypropri from '../../Images/dummypropri.png'
import PopularSearch from '../PopularSearch'
import PopularService from '../PopularService'

function Propitorship() {

    const { id } = useParams();
    const [Newbussiness, setNewBussiness] = useState([]);
    const [Newbussiness1, setNewBussiness1] = useState([]);
    const [Newbussiness11, setNewBussiness11] = useState([]);


    const getUsers = async () => {
        try {
            const { data } = await axios.get(`https://api.compliancekare.com/api/Compliance/RegistrationProcessList?BusinessId=${id}`)
            setNewBussiness(data.data);
            console.log("data", data);
        } catch (error) {
            console.error("Error fetching data:", error);
            // Handle error appropriately, e.g., show error message to the user
        }
    }
    const getUser1 = async () => {
        try {
            const { data } = await axios.get(`https://api.compliancekare.com/api/Compliance/BusinessDetailList?BusinessId=${id}`)
            setNewBussiness1(data.id);
            console.log("Vishnu", data);
        } catch (error) {
            console.error("Error fetching data:", error);
            // Handle error appropriately, e.g., show error message to the user
        }
    }
    const getUser11 = async () => {
        try {
            const { data } = await axios.get(`https://api.compliancekare.com/api/Compliance/BusinessDetailList?BusinessId=${id}`)
            setNewBussiness11(data.services);
            console.log("Vishnu", data);
        } catch (error) {
            console.error("Error fetching data:", error);
            // Handle error appropriately, e.g., show error message to the user
        }
    }
    useEffect(() => {
        const fetchData = async () => {
            await getUsers();
            await getUser1();
            await getUser11();
        };

        fetchData();
    }, [id]);


    return (
        <>
            <TopHeader />
            <Navbar />
            <>
                <div className='container'>
                    <div class="bcca-breadcrumb">
                        {<div class="bcca-breadcrumb-item"> {Newbussiness1.businessName}</div>}

                        <div class="bcca-breadcrumb-item">NEW BUSINESS</div>
                        <div class="bcca-breadcrumb-item">
                            <Link to="/">
                                Home
                            </Link>
                        </div>
                    </div>
                    <div id="bg" />

                    <div className="blg_row">
                        <div class="container">
                            <div class="row">
                                <div className="col">
                                    {

                                        <div className="blg_card" style={{ height: "400px", borderRadius: "11px", boxShadow: "1px 1px 0px 2px gray" }} >
                                            <div className=' d-flex justify-content-between px-1' style={{ background: "#115887", borderRadius: "4px" }}>
                                                <p className='text-white p-3 mt-2' style={{ fontSize: "20px" }}>{Newbussiness1.businessName} Pricing Summary: ₹{Newbussiness1.price}.00</p>
                                                <button type="button" className="btn mt-3 px-2" style={{ background: "green", height: "40px" }}>Get Started</button>
                                            </div>
                                            <div className='p-3'>
                                                <li style={{ listStyle: "none" }} className='d-flex gap-2'>
                                                    <img style={{ width: "20px", height: "20px" }} src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRSb226LzcEEHDKh_mze5ACRs3Dm8xP4eIT3Q&usqp=CAU" alt="" />
                                                    <p>Market Price:</p><s>₹{Newbussiness1.marketPrice}.00</s>
                                                </li>
                                                <li style={{ listStyle: "none" }} className='d-flex gap-2'>
                                                    <img style={{ width: "20px", height: "20px" }} src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRSb226LzcEEHDKh_mze5ACRs3Dm8xP4eIT3Q&usqp=CAU" alt="" />
                                                    <p>You Save:</p>₹{Newbussiness1.savePrice}.00
                                                </li>
                                                <li style={{ listStyle: "none" }} className='d-flex gap-2'>
                                                    <img style={{ width: "20px", height: "20px" }} src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRSb226LzcEEHDKh_mze5ACRs3Dm8xP4eIT3Q&usqp=CAU" alt="" />
                                                    <p>Government Fee:</p><p className='text-success'>Included</p>
                                                </li>
                                            </div>
                                        </div>

                                    }
                                </div>

                                <div class="col">
                                    <div className="blg_card" style={{ height: "400px", borderRadius: "11px", boxShadow: "1px 1px 0px 2px gray" }}>
                                        {<div className=' d-flex justify-content-between px-1  ' style={{ background: "#115887", borderRadius: "4px" }}>
                                            <p className='text-white p-3 mt-2 ' style={{ fontSize: "22px" }}>Startup Package fees :₹{Newbussiness1.packageFee}.00</p>
                                            <button type="button" class="btn mt-3 px-2 " style={{ background: "green", height: "40px" }}>Get Started</button>
                                        </div>}

                                        <div className='Card_Top'>
                                            <div className='row'>
                                                {Newbussiness11 && Newbussiness11?.map((item, index) => (

                                                    <div className='col-lg-6 d-flex'>
                                                        <img style={{ width: "20px", height: "20px" }} src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRSb226LzcEEHDKh_mze5ACRs3Dm8xP4eIT3Q&usqp=CAU" />
                                                        <p className='text-paraa'>{item.service}</p>
                                                    </div>

                                                ))}
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="blg_left_column">
                            <div className="blg_card">
                                {/* MAIN (Center website) */}
                                <div className="pg_main">
                                    {
                                        <>
                                            <h1>
                                                {Newbussiness1.businessName}
                                            </h1>
                                            <hr />

                                            <div >

                                                <div dangerouslySetInnerHTML={{ __html: Newbussiness1.proprietorshipDescription || '' }}></div>
                                            </div>
                                        </>
                                    }

                                </div>
                            </div>
                            <div className=" blg_card">
                                {<h2 >{Newbussiness1.businessName} Registration Process</h2>}
                                {Newbussiness.length > 0 && (

                                    <>
                                        {console.log("hghggh", Newbussiness)}
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <img
                                                    src="https://assets.vakilsearch.com/expert.svg"
                                                    alt="Cute dog wrapped in a blanket"
                                                    className="img-circle w-50"
                                                    style={{ borderRadius: "50%" }}
                                                />
                                            </div>

                                            <div className="col-sm-8">
                                                <div className="description">
                                                    <h2>Day 1-2</h2>
                                                    <div dangerouslySetInnerHTML={{ __html: Newbussiness[0]?.registrationProcess || '' }}></div>
                                                </div>

                                            </div>

                                        </div>

                                        <div className="row">
                                            <div className="col-sm-8">
                                                <div className="description">
                                                    <h2>Day 2-3</h2>
                                                    <div dangerouslySetInnerHTML={{ __html: Newbussiness[1]?.registrationProcess || '' }}></div>
                                                </div>

                                            </div>

                                            <div className="col-sm-4">
                                                <img
                                                    src="https://assets.vakilsearch.com/docu.svg"
                                                    alt="Cute dog wrapped in a blanket"
                                                    className="img-circle w-50"
                                                    style={{ borderRadius: "50%" }}
                                                />
                                            </div>

                                        </div>

                                        <div className="row">
                                            <div className="col-sm-4">
                                                <img
                                                    src="https://assets.vakilsearch.com/docu.svg"
                                                    alt="Cute dog wrapped in a blanket"
                                                    className="img-circle w-50"
                                                    style={{ borderRadius: "50%" }}
                                                />
                                            </div>

                                            <div className="col-sm-8">
                                                <div className="description">
                                                    <h2>Day 3-4</h2>
                                                    <div dangerouslySetInnerHTML={{ __html: Newbussiness[2]?.registrationProcess || '' }}></div>
                                                </div>

                                            </div>

                                        </div>

                                        <div className="row">
                                            <div className="col-sm-8">
                                                <div className="description">
                                                    <h2>Day 4-5</h2>
                                                    <div dangerouslySetInnerHTML={{ __html: Newbussiness[3]?.registrationProcess || '' }}></div>
                                                </div>

                                            </div>

                                            <div className="col-sm-4">
                                                <img
                                                    src="https://assets.vakilsearch.com/certificate.svg"
                                                    alt="Cute dog wrapped in a blanket"
                                                    className="img-circle w-50"
                                                    style={{ borderRadius: "50%" }}
                                                />
                                            </div>

                                        </div>
                                    </>
                                )}

                            </div>


                        </div>

                    </div>

                </div>






                <PopularService />



            </>




            <Footer />
        </>
    )
}

export default Propitorship